import Cookies from "js-cookie";

export const insertItem = (array, object) => {
  const newArray = array.slice();
  newArray.splice(object.index, 0, object);
  return newArray;
};

export const removeItem = (array, object) => {
  return array.filter((item) => item.id !== object.id);
};

export const updateObjectInArray = (array, object, key = "id") => {
  return array.map((item) => {
    if (item[key] !== object[key]) {
      return item;
    } else
      return {
        ...item,
        ...object,
      };
  });
};

export const cleanUpLocalStorage = () => {
  Cookies.remove("jwt");
  localStorage.removeItem("jwt");
};
